import React from 'react'
import { Text } from '../../styles/Components'
import { useField, useFormState } from 'react-final-form'
import AutoComplete from '../../components/autocomplete'
import { mq } from '../../helpers'
import styled from '@emotion/styled'
import { gsColors } from '../../styles/Variables'

const Wrapper = styled.div`
  input {
    width: 100% !important;
    height: 55px;
    border: none;
    background-color: transparent;
    color: #000;
    font-family: 'Euclid';
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    letter-spacing: 0.36px;
    border-bottom: 1px solid
      ${(props) => (props.hasError ? gsColors.errorRed : '#000')};
    padding: 12px 0;
    z-index: 9998;
    border-radius: 0;

    &::placeholder {
      color: ${(props) => (props.hasError ? gsColors.errorRed : '#000')};
      opacity: 0.5;
    }

    &:focus {
      outline: none;
    }

    ${mq('max', '768px')} {
      font-size: 16px;
    }
  }
`

/* AutoCompleteField:
 * wrapper of current Google AutoComplete component
 * to use within final form
 *
 * @param {string} name
 */
const AutoCompleteField = React.forwardRef(({ name, placeholder }, ref) => {
  const { submitFailed } = useFormState({ subscription: { submitFailed: true } })
  const { input, meta } = useField(name)

  const hasError = submitFailed && meta?.error

  const handleSelect = (place) => {
    input.onChange(place.formatted_address)
  }

  return (
    <Wrapper ref={ref} hasError={hasError}>
      <AutoComplete
        className="place-autocomplete"
        placeholder={placeholder}
        onPlaceSelected={handleSelect}
        {...input}
      />
      {!!hasError && (
        <Text color={gsColors.errorRed} margin="6px 0 0 0">
          {meta?.error || 'Required'}
        </Text>
      )}
    </Wrapper>
  )
})

export default AutoCompleteField
